import React from "react";
import "./GameControlSpymaster.css";
import { useWebSocket } from "../../context/WebSocketContext";
import Cupboard from "../Cupboard/Cupboard";
import Codebreaker from "../Codebreaker/Codebreaker";
import Keypad from "../Keypad/Keypad";
import FlowTimeline from "../FlowTimeline/FlowTimeline";
import StartKeys from "../StartKeys/StartKeys";
import Suitcase from "../Suitcase/Suitcase";
import RiddleCard from "../RiddleCard/RiddleCard";

const LANGUAGES = ["EN", "DA"];

const GameControlSpymaster = () => {
    const {
        cupboardShelves,
        cupboardOpen,
        codebreakerStatus,
        keypadStatus,
        gameFlow,
        startKeysSolved,
        startKeyPins,
        middlemanConnected,
        suitcaseStatuses,
        waitingForRestart,
        waitingForControllers,
        readyToRestart,
        gameLanguage,
        sendLanguage,
        sendFailure,
        gameControllerConnected,
        socketRef,
        gameDetailConfig
    } = useWebSocket();

    const handleOverwrite = (id) => {
        if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
            socketRef.current.send(`overwrite_flow ${gameDetailConfig.game_id} ${id}`);
        }
    };

    const showStatusCard = true;

    const statusCardContent = (
        <div className="game-status-content">
            <div className="game-status-row">
                <span className="game-status-label">Language:</span>
                <div className="language-btn-group">
                    {LANGUAGES.map((lang) => (
                        <button
                            key={lang}
                            className={`language-btn${gameLanguage?.toUpperCase() === lang ? " active" : ""}`}
                            onClick={() => sendLanguage(lang)}
                        >
                            {lang}
                        </button>
                    ))}
                </div>
            </div>
            {!gameControllerConnected && (
                <div className="game-status-row game-status-connecting">
                    <span className="game-status-indicator blinking-dot" />
                    <span>Connecting to game controller...</span>
                </div>
            )}
            {gameControllerConnected && !readyToRestart && !waitingForRestart && (
                <div className="game-status-row game-status-running">
                    <span className="game-status-indicator blinking-dot" />
                    <span>Game is running</span>
                </div>
            )}
            <div className="game-status-row">
                <button
                    className="failure-btn"
                    onClick={() => {
                        if (window.confirm("Play failure video on all suitcases?")) {
                            sendFailure();
                        }
                    }}
                >
                    Play failure video on suitcases
                </button>
            </div>
            {readyToRestart && (
                <div className="game-status-row game-status-restarting">
                    <span className="game-status-indicator blinking-dot" />
                    <span>Restarting</span>
                </div>
            )}
            {!readyToRestart && waitingForRestart && (
                <div className="game-status-row game-status-warning">
                    <span className="game-status-indicator" />
                    <span>Restarting</span>
                </div>
            )}
            {waitingForControllers && waitingForControllers.length > 0 && (
                <div className="game-status-row game-status-warning">
                    <span className="game-status-label">Waiting for:</span>
                    <span className="game-status-value">{waitingForControllers.join(", ")}</span>
                </div>
            )}
        </div>
    );

    return (
        <div id="game-wrapper">
            <FlowTimeline
                flow={gameFlow}
                onOverwrite={handleOverwrite}
                connected={true}
            />
            {showStatusCard && (
                <RiddleCard
                    title="Game Status"
                    mainInfo={statusCardContent}
                    layout="full-size"
                    displayFlexColumn={true}
                />
            )}
            <Cupboard shelves={cupboardShelves} isOpen={cupboardOpen}/>
            {suitcaseStatuses.map(({ id, status }) => (
                <Suitcase key={id} id={id} status={status} />
            ))}
            {codebreakerStatus && (
                <Codebreaker status={codebreakerStatus} />
            )}
            {keypadStatus && (
                <Keypad status={keypadStatus} />
            )}
            <StartKeys
                solved={startKeysSolved}
                pins={startKeyPins}
                connected={middlemanConnected}
            />
        </div>
    );
};

export default GameControlSpymaster;